/* import __COLOCATED_TEMPLATE__ from './reviewable-tags.hbs'; */
import Component from "@ember/component";

export default Component.extend({});
